<template>
    <div class='advertising_wrapper' ref='wrapper'>
        <div class='advertise_banner'>
            <img alt=''
                 class='banner_img'
                 src='../../assets/images/advertise_banner2.png'>
        </div>
        <div class='nav_bar_box' ref='detailNav'>
            <div class='nav_bar' :class='{fixed: isFixed}'>
                <div v-for='(item, index) in navList'
                     :key='index'
                     @click='handleNavClick(index)'
                     :class='{active:currentNav === index}'
                     class='nav_item'>
                    {{item}}
                </div>
            </div>
        </div>
        <div class='moduleBox moduleBox1' ref='module1'>
            <img src='../../assets/images/advertise_intruduct2.png'
                 alt=''
                 @load='handleLoad(1)'
                 class='intruduct_img'>
            <div class='follow_btn' @click='handleFollow'>去关注</div>
        </div>
        <div class='moduleBox' ref='module2'>
            <img src='../../assets/images/advertise_common2.png'
                 alt=''
                 @load='handleLoad(2)'
                 class='know_img'>
        </div>
        <div class='moduleBox' ref='module3'>
            <img src='../../assets/images/advertise_know2.png'
                 alt=''
                 @load='handleLoad(3)'
                 class='common_img'>
        </div>
    </div>
</template>

<script>
import './Advertising.less'

export default {
    name: 'Advertising',
    data() {
        return {
            navList: [ '产品介绍', '服务须知', '常见问题' ],
            currentNav: 0,
            imgLoad: [],
            windowHeight: null,
            scrollHeight: null,
            offsetTopModule1: null,
            offsetTopModule2: null,
            offsetTopModule3: null,
            fixedHeight: null,
            offsetHeight: null,
            isFixed: false
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll)
    },
    methods: {
        /**
         * nav切换
         * @param index
         */
        handleNavClick(index) {
            this.$nextTick(() => {
                if(this.currentNav === index) return
                this.currentNav = index
                if (index === 0) {
                    document.documentElement.scrollTo(
                        0,
                        this.offsetTopModule1 - this.offsetHeight
                    )
                }
                if (index === 1) {
                    document.documentElement.scrollTo(
                        0,
                        this.offsetTopModule2 - this.offsetHeight
                    )
                }
                if (index === 2) {
                    document.documentElement.scrollTo(
                        0,
                        this.offsetTopModule3 - this.offsetHeight
                    )
                }
            })
        },
        /**
         * 图片加载完毕
         * @param index
         */
        handleLoad(index) {
            this.imgLoad.push(index)
            if (this.imgLoad.length === 3) {
                this.$nextTick(() => {
                    this.fixedHeight = this.$refs.detailNav.offsetTop
                    this.offsetHeight = this.$refs.detailNav.offsetHeight
                    this.windowHeight = document.documentElement.clientHeight || document.body.clientHeight
                    this.scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight
                    this.offsetTopModule1 = this.$refs.module1.offsetTop
                    this.offsetTopModule2 = this.$refs.module2.offsetTop
                    this.offsetTopModule3 = this.$refs.module3.offsetTop
                })
            }
        },
        /**
         * 监听页面滚动
         */
        handleScroll() {
            let scrollTop = document.documentElement.scrollTop
            this.isFixed = scrollTop > this.fixedHeight
            if(this.offsetTopModule3 - this.offsetHeight > scrollTop && scrollTop > this.offsetTopModule2 - this.offsetHeight) {
                this.currentNav = 1
            }
            if(scrollTop > this.offsetTopModule3 - this.offsetHeight - 20) {
                this.currentNav = 2
            }
            if(scrollTop < this.offsetTopModule2 - this.offsetHeight) {
                this.currentNav = 0
            }
            if(scrollTop+this.windowHeight>=this.scrollHeight) {
                this.currentNav = 2
            }
        },
        handleFollow() {
            window.location.href = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzA5MTk0NzY1NQ==&scene=124#wechat_redirect'
        }
    }
}
</script>
